import {
  lmsModuleReportTypes,
  shippingModuleReportTypes,
} from '../../constants';
import './ReportCard.scss';

interface Props {
  title: string;
  description: string;
  type: string;
  onViewFilter: (type: string, title: string) => void;
}

export default function ReportCard({
  title,
  description,
  type,
  onViewFilter,
}: Props) {
  let classes = 'card-body ';

  if (shippingModuleReportTypes.includes(type)) {
    classes += 'report-card-left-border-purple';
  } else if (lmsModuleReportTypes.includes(type)) {
    classes += 'report-card-left-border-green';
  }

  return (
    <div className='ubbe-card report'>
      <div className={classes}>
        <div className='d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-center gap-2'>
          <div className='d-flex flex-column'>
            <h3
              className='mb-1 h4 lex-20-500'
              id='report_title'
            >
              {title}
            </h3>
            <p className='card-text mt-3 lex-14-300'>{description}</p>
          </div>
          <div className='text-start'>
            <button
              className='btn btn-ubbe-secondary'
              onClick={() => onViewFilter(type, title)}
            >
              View Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
